import React, { useState } from 'react'
import "./Stepper.css"
const Stepper = () => {
  const [step, setStep] = useState(1);
  const [selectedDate, setSelectedDate] = useState("");

  const nextStep = () => {
    if (step === 1 && !selectedDate) return;
    setStep(step + 1);
  };

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  const steps = ["Date", "Time", "Package", "Other"];

  return (
      <div className="stepper">
        {steps.map((label, index) => {
          const stepNumber = index + 1;
          return (
            <div key={index} className="step-wrapper">
              <div
                className={`step-circle ${
                  step === stepNumber
                    ? "active"
                    : step > stepNumber
                    ? "completed"
                    : ""
                }`}
              >
                {stepNumber}
              </div>
              <p>{label}</p>
              {index !== steps.length - 1 && (
                <div
                  className={`step-line ${step > stepNumber ? "active" : ""}`}
                />
              )}
            </div>
          );
        })}
      </div>
  )
}

export default Stepper